/**
 * React Query (TanStack Query) configuration
 */

import { QueryClient } from "@tanstack/react-query";

/**
 * Create and configure the global QueryClient instance
 */
export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			// Default options for all queries
			staleTime: 5 * 60 * 1000, // 5 minutes
			gcTime: 30 * 60 * 1000, // 30 minutes (cache time)
			retry: 2,
			refetchOnWindowFocus: false,
			refetchOnMount: false,
		},
	},
});
